/**
 * @generated SignedSource<<0321e14b9dc2c9792d773a557bd06c10>>
 * @relayHash 378edbbb521b8e86065c18820b473d24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fb8d3660b15899cb3e02d7edfd1fa28ab64319daa49ecbf02bf71ac04f6336ce

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fb8d3660b15899cb3e02d7edfd1fa28ab64319daa49ecbf02bf71ac04f6336ce",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "issueByKey",
            "attachments"
          ]
        }
      ]
    },
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
